module.exports = __webpack_public_path__ + "img/Aura_shine.b89ea29e.png";